import { render, staticRenderFns } from "./EventFilters.vue?vue&type=template&id=215644ae&scoped=true&"
import script from "./EventFilters.vue?vue&type=script&lang=js&"
export * from "./EventFilters.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/filters.css?vue&type=style&index=0&id=215644ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215644ae",
  null
  
)

export default component.exports